

























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import ExtendOfferExpirationTrigger from './ExtendOfferExpirationTrigger.coffee'

settings =
  name: 'ExtendOfferExpirationTriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [ExtendOfferExpirationTrigger.trigger()]

    computed:
      modalConfig: -> @modal.config || {}

    methods:
      modalData: ->
        days: 7

export default VueOptions.vue settings
